import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-common-dropdown',
  templateUrl: './dropdown-common.component.html',
  styleUrls: ['./dropdown-common.component.scss']
})
export class DropdownCommonComponent {
  // Dữ liệu để hiển thị trong dropdown
  @Input() options: string[] = [];
  
  // Giá trị được chọn
  @Input() selectedValue: string = '';
  
  // hiện lable
  @Input() isDisplayLable: boolean = true; 
  

  // Sự kiện khi giá trị thay đổi
  @Output() selectedValueChange: EventEmitter<string> = new EventEmitter<string>();

  // Hàm để xử lý khi người dùng thay đổi lựa chọn
  onChange(selected: string) {
    this.selectedValueChange.emit(selected);
  }
}
